import React from 'react';

import { commercialPackageShape } from '../prop-types';

function CommercialPackageLabel({ model }) {
  return <div className="mt-2">{model.value}</div>;
}

CommercialPackageLabel.propTypes = {
  model: commercialPackageShape.isRequired,
};

export default CommercialPackageLabel;
